/* unplugin-vue-components disabled */import script from "./item-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./item-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./item-dialog.vue?vue&type=style&index=0&id=2007c40d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2007c40d"]])

export default __exports__